import React from 'react'
import { CreateRecipe } from '../Components/CreateRecipe/CreateRecipe'

const Form = () => {
  return (
    <CreateRecipe/>
  )
}

export {Form}
